import { render, staticRenderFns } from "./HelpMenuContentDetails.vue?vue&type=template&id=20668420"
import script from "./HelpMenuContentDetails.vue?vue&type=script&lang=js"
export * from "./HelpMenuContentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports